module.exports = __webpack_public_path__ + "media/images/ArticleTypesBusiness-67a380e30d50f40aa5700d428d3aade2.jpg";